/**
 * Top-bar indeterminate progress indicator used as <Suspense> fallback
 * for route-level code splitting (Story 13.14, Decision 2a).
 *
 * @module components/loading/RouteProgressBar
 */

/**
 * Thin (3px) brand-coloured bar fixed to the top of the viewport.
 * No props — fully self-contained, indeterminate animation, design-token colours.
 */
export function RouteProgressBar(): JSX.Element {
  return (
    <div
      role="progressbar"
      aria-busy="true"
      aria-label="Loading page"
      className="pointer-events-none fixed inset-x-0 top-0 z-[9999] h-[3px] overflow-hidden bg-accent-gold/20"
    >
      <div className="h-full w-1/3 animate-route-progress bg-accent-gold" />
    </div>
  );
}

export default RouteProgressBar;
